import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import FormControl from '@mui/material/FormControl';


import {
    Box,
    Grid,
    Typography,
    Tooltip,
    IconButton,
    Chip,
    InputBase,
    Divider,
    Snackbar,
    Alert,
    Modal,
    Card,
    CardContent,
    Stack,
    Avatar,
    TextField,
    FormHelperText,
    Button,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material';

import MenuItem from '@mui/material/MenuItem';

import Skeleton from '@mui/material/Skeleton';

import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
import VisibilityIcon from '@mui/icons-material/Visibility';

import BusinessIcon from '@mui/icons-material/Business';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import TimelineIcon from '@mui/icons-material/Timeline';
import CloseIcon from '@mui/icons-material/Close';
import CallIcon from '@mui/icons-material/Call';
import ForumIcon from '@mui/icons-material/Forum';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import EventIcon from '@mui/icons-material/Event';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';



const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
        xs: '95%',
        md: 900
    },
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 3,
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const EnquiryComp = (props) => {
    const [openDetailsModal, setOpenDetailsModal] = React.useState(false);
    const [selectedEnquiry, setSelectedEnquiry] = React.useState({});

    const FormatDateTime = (date) => {

        if (!date) return 'N/A';

        let formatDate =
            new Date(
                new Date(date).getTime()
                - (new Date(date).getTimezoneOffset() * 60000)
            )
                .toISOString()
                .substr(0, 19)
                .replace('T', ' ');

        return formatDate;
    };

    const formatDuration = (seconds) => {

        if (!seconds) return 'Not Available';

        const mins = Math.floor(seconds / 60);

        const secs = seconds % 60;

        return `${mins}m ${secs}s`;

    };


    const formatEnquiryDate = (value) => {
        if (!value) return "Not available";

        const date = new Date(value);

        if (Number.isNaN(date.getTime())) return value;

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    const getEnquiryValue = (value) => {
        if (value === null || value === undefined || value === "") {
            return "Not provided";
        }

        return value;
    };

    const getEnquiryTypeColor = (type) => {
        const normalized = (type || "").toLowerCase();

        if (normalized.includes("student")) return "#2563eb";
        if (normalized.includes("indian")) return "#0f766e";
        if (normalized.includes("german")) return "#7c3aed";

        return "#475569";
    };

    const DetailItem = ({ label, value, fullWidth = false }) => (
        <Grid item xs={12} sm={fullWidth ? 12 : 6}>
            <Box
                sx={{
                    p: 2,
                    height: "100%",
                    borderRadius: 2.5,
                    bgcolor: "#f8fafc",
                    border: "1px solid #e8edf3",
                    overflowWrap: "anywhere"
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        color: "#64748b",
                        fontWeight: 600,
                        display: "block",
                        mb: 0.75,
                        textTransform: "uppercase",
                        letterSpacing: 0.5
                    }}
                >
                    {label}
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: "#172b4d",
                        fontWeight: 600,
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.7
                    }}
                >
                    {getEnquiryValue(value)}
                </Typography>
            </Box>
        </Grid>
    );

    const EnquirySection = ({ title, subtitle, children }) => (
        <Card
            elevation={0}
            sx={{
                mb: 3,
                borderRadius: 3,
                border: "1px solid #e2e8f0",
                overflow: "hidden"
            }}
        >
            <Box
                sx={{
                    px: { xs: 2, md: 3 },
                    py: 2,
                    borderBottom: "1px solid #e8edf3",
                    bgcolor: "#fff"
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontSize: "1rem",
                        fontWeight: 750,
                        color: "#102a43"
                    }}
                >
                    {title}
                </Typography>

                {subtitle && (
                    <Typography
                        variant="body2"
                        sx={{ mt: 0.5, color: "#64748b" }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>

            <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                {children}
            </CardContent>
        </Card>
    );

    {/* ENQUIRY DETAILS MODAL */ }




    const ViewEnquiryDetails = (item) => {
        setSelectedEnquiry(item);
        setOpenDetailsModal(true);
    };

    return (
        <Box>

            {/* TOP BAR */}
            <Box>

                <Grid container>
                    <Grid item xs={12} md={4} mt={2}>
                        <Paper
                            component="form"
                            sx={{
                                p: '2px 4px',
                                height: 40,
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%'
                            }}
                        >
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search By Name, Number..."
                                value={props.mystate.searchObj?.txtEnquirySearchName || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtEnquirySearchName')
                                }
                            />

                            <IconButton sx={{ p: '10px' }}>
                                <SearchIcon
                                    onClick={() =>
                                        props.SearchLeadList('direct', '')
                                    }
                                />
                            </IconButton>

                            <Divider
                                sx={{ height: 28, m: 0.5 }}
                                orientation="vertical"
                            />

                            <IconButton sx={{ p: '10px' }}>
                                <CachedIcon
                                    onClick={() =>
                                        props.SearchLeadList('reload', '')
                                    }
                                />
                            </IconButton>

                        </Paper>
                    </Grid>

                    <Grid md={3} mt={2}>
                        <FormControl sx={{ m: 1, minWidth: 200, marginTop: 0.2, }} size="small">
                            <TextField
                                size='small'
                                select
                                //  value={props.mystate.searchObj.ddlEnquiryType}
                                value={props.mystate.searchObj.ddlEnquiryType || ''}
                                label="Enquiry Type"
                                onChange={(e) => props.HandleInputs(e, 'ddlEnquiryType')}
                            >

                                <MenuItem value={'All'}>{'All'}</MenuItem>
                                <MenuItem value={'Student'}>{'Student'}</MenuItem>
                                <MenuItem value={'Indian Partner'}>{'Indian Partner'}</MenuItem>
                                <MenuItem value={'German Partner'}>{'German Partner'}</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={5} mt={2} textAlign={'right'}>

                        {/* <Tooltip arrow title="New Enquiry">

                            <IconButton
                                onClick={() =>
                                    props.NavigateTo('enquiry/new')
                                }
                                className='grey-theme-btn'
                            >
                                <AddIcon />
                            </IconButton>

                        </Tooltip> */}

                        {/* <Tooltip arrow title="Filter">

                            <IconButton
                                onClick={() => props.ToggleFilter()}
                                className='grey-theme-btn'
                            >
                                <FilterListIcon />
                            </IconButton>

                        </Tooltip> */}

                    </Grid>

                </Grid>

            </Box>

            {/* TABLE */}
            <Box mt={3}>

                {
                    props.mystate.getLeadList === false ?

                        window.innerWidth > 567 ?

                            <Paper
                                sx={{
                                    width: '100%',
                                    overflow: 'hidden'
                                }}
                            >

                                <TableContainer
                                    sx={{
                                        maxHeight: 'calc(100vh - 250px)'
                                    }}
                                >

                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>

                                                {/* SR NO */}
                                                <TableCell className="table-head-cell">
                                                    Sr No
                                                </TableCell>

                                                {/* DATE */}
                                                <TableCell className="table-head-cell">
                                                    Added Date
                                                </TableCell>

                                                {/* ENQUIRY */}
                                                <TableCell className="table-head-cell">
                                                    Enquiry
                                                </TableCell>

                                                {/* CONTACT */}
                                                <TableCell className="table-head-cell">
                                                    Contact Details
                                                </TableCell>

                                                {/* ENQUIRY DETAILS */}
                                                <TableCell className="table-head-cell">
                                                    Enquiry Details
                                                </TableCell>

                                                {/* STATUS */}
                                                <TableCell className="table-head-cell">
                                                    Status
                                                </TableCell>

                                                {/* ACTION */}
                                                <TableCell className="table-head-cell">
                                                    Action
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>

                                        <TableBody>

                                            {
                                                props.mystate.enquiryList.length > 0 ?

                                                    props.mystate.enquiryList.map((item, i) => (

                                                        <TableRow
                                                            hover
                                                            key={item._id}
                                                        >

                                                            {/* ================= SR NO ================= */}
                                                            <TableCell>
                                                                {
                                                                    (
                                                                        (
                                                                            props.mystate.setNo - 1
                                                                        ) *
                                                                        props.mystate.perSet
                                                                    ) + i + 1
                                                                }
                                                            </TableCell>


                                                            {/* ================= DATE ================= */}
                                                            <TableCell>
                                                                {
                                                                    FormatDateTime(
                                                                        item.enquiry_added_on
                                                                    )
                                                                }
                                                            </TableCell>


                                                            {/* ================= ENQUIRY ================= */}
                                                            <TableCell>

                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    {item.enquiry_name || 'NA'}
                                                                </Typography>

                                                                <Chip
                                                                    label={
                                                                        item.enquiry_type || 'NA'
                                                                    }
                                                                    size="small"
                                                                    sx={{
                                                                        mt: 0.5,
                                                                        fontWeight: 600,
                                                                        backgroundColor:
                                                                            item.enquiry_type === 'Student'
                                                                                ? '#e0f2fe'
                                                                                : item.enquiry_type === 'Indian Partner'
                                                                                    ? '#dcfce7'
                                                                                    : '#f3e8ff',
                                                                        color:
                                                                            item.enquiry_type === 'Student'
                                                                                ? '#0369a1'
                                                                                : item.enquiry_type === 'Indian Partner'
                                                                                    ? '#15803d'
                                                                                    : '#7e22ce'
                                                                    }}
                                                                />

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    display="block"
                                                                    sx={{ mt: 0.5 }}
                                                                >
                                                                    {item.enquiry_city || 'NA'}
                                                                </Typography>

                                                            </TableCell>


                                                            {/* ================= CONTACT DETAILS ================= */}
                                                            <TableCell>

                                                                {
                                                                    item.enquiry_contact_name &&

                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            fontWeight: 600
                                                                        }}
                                                                    >
                                                                        {item.enquiry_contact_name}
                                                                    </Typography>
                                                                }

                                                                <Typography
                                                                    variant="caption"
                                                                    display="block"
                                                                    color="text.secondary"
                                                                >
                                                                    {item.enquiry_mobile || 'NA'}
                                                                </Typography>

                                                                <Typography
                                                                    variant="caption"
                                                                    display="block"
                                                                    color="text.secondary"
                                                                    sx={{
                                                                        lineBreak: 'anywhere',
                                                                        maxWidth: 180
                                                                    }}
                                                                >
                                                                    {item.enquiry_email || 'NA'}
                                                                </Typography>

                                                            </TableCell>


                                                            {/* ================= ENQUIRY DETAILS ================= */}
                                                            <TableCell>

                                                                {/* -------- STUDENT -------- */}
                                                                {
                                                                    item.enquiry_type === 'Student' && (
                                                                        <Box>

                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                            >
                                                                                German Level:{' '}
                                                                                <span style={{ fontWeight: 400 }}>
                                                                                    {
                                                                                        item.enquiry_student_german_level ||
                                                                                        'NA'
                                                                                    }
                                                                                </span>
                                                                            </Typography>

                                                                            <Typography
                                                                                variant="body2"
                                                                            >
                                                                                B2 Pass Year:{' '}
                                                                                <span>
                                                                                    {
                                                                                        item.enquiry_student_b2_pass_year ||
                                                                                        'NA'
                                                                                    }
                                                                                </span>
                                                                            </Typography>

                                                                            <Typography
                                                                                variant="body2"
                                                                                color="text.secondary"
                                                                            >
                                                                                Language / Enquiry:{' '}
                                                                                {
                                                                                    item.enquiry_student_language_enquiry_name ||
                                                                                    'NA'
                                                                                }
                                                                            </Typography>

                                                                        </Box>
                                                                    )
                                                                }


                                                                {/* -------- INDIAN PARTNER -------- */}
                                                                {
                                                                    item.enquiry_type === 'Indian Partner' && (
                                                                        <Box>

                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                            >
                                                                                B2 Graduates:{' '}
                                                                                <span style={{ fontWeight: 400 }}>
                                                                                    {
                                                                                        item.enquiry_indian_partner_b2_graduates ||
                                                                                        'NA'
                                                                                    }
                                                                                </span>
                                                                            </Typography>

                                                                        </Box>
                                                                    )
                                                                }


                                                                {/* -------- GERMAN PARTNER -------- */}
                                                                {
                                                                    item.enquiry_type === 'German Partner' && (
                                                                        <Box>

                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                            >
                                                                                Hiring Requirement:{' '}
                                                                                <span style={{ fontWeight: 400 }}>
                                                                                    {
                                                                                        item.enquiry_german_partner_hiring_requirement ||
                                                                                        'NA'
                                                                                    }
                                                                                </span>
                                                                            </Typography>

                                                                            {
                                                                                item.enquiry_german_partner_msg &&

                                                                                <Typography
                                                                                    variant="caption"
                                                                                    color="text.secondary"
                                                                                    display="block"
                                                                                    sx={{
                                                                                        mt: 0.5,
                                                                                        maxWidth: 250
                                                                                    }}
                                                                                >
                                                                                    {item.enquiry_german_partner_msg}
                                                                                </Typography>
                                                                            }

                                                                        </Box>
                                                                    )
                                                                }

                                                            </TableCell>


                                                            {/* ================= STATUS ================= */}
                                                           
<TableCell>
    <Stack spacing={0.75} alignItems="flex-start">
        <Chip
            label={item.enquiry_status || 'N/A'}
            size="small"
            sx={{
                backgroundColor:
                    item.enquiry_status === 'Pending'
                        ? '#fef3c7'
                        : item.enquiry_status === 'Call Back'
                            ? '#dbeafe'
                            : item.enquiry_status === 'Dead'
                                ? '#fee2e2'
                                : item.enquiry_status === 'RNR'
                                    ? '#f3e8ff'
                                    : item.enquiry_status === 'On Hold'
                                        ? '#ffedd5'
                                        : item.enquiry_status === 'Qualified'
                                            ? '#dcfce7'
                                            : '#e2e8f0',

                color:
                    item.enquiry_status === 'Pending'
                        ? '#92400e'
                        : item.enquiry_status === 'Call Back'
                            ? '#1d4ed8'
                            : item.enquiry_status === 'Dead'
                                ? '#b91c1c'
                                : item.enquiry_status === 'RNR'
                                    ? '#6b21a8'
                                    : item.enquiry_status === 'On Hold'
                                        ? '#9a3412'
                                        : item.enquiry_status === 'Qualified'
                                            ? '#166534'
                                            : '#475569',

                fontWeight: 600
            }}
        />

        {item.enquiry_status === 'Call Back' &&
            item.call_back_date_time && (
                <Typography
                    variant="caption"
                    sx={{
                        color: '#1d4ed8',
                        fontWeight: 500,
                        whiteSpace: 'nowrap'
                    }}
                >
                    <EventIcon
                        sx={{
                            fontSize: 14,
                            verticalAlign: 'middle',
                            mr: 0.5
                        }}
                    />
                    {item.call_back_date_time}
                </Typography>
            )}

        {item.enquiry_status === 'Dead' &&
            item.dead_date_time && (
                <Typography
                    variant="caption"
                    sx={{
                        color: '#b91c1c',
                        fontWeight: 500,
                        whiteSpace: 'nowrap'
                    }}
                >
                    <EventIcon
                        sx={{
                            fontSize: 14,
                            verticalAlign: 'middle',
                            mr: 0.5
                        }}
                    />
                    {item.dead_date_time}
                </Typography>
            )}
    </Stack>
</TableCell>



                                                            {/* ================= ACTION ================= */}
                                                            <TableCell>

                                                                <Box
                                                                    sx={{
                                                                        display: 'grid',
                                                                        gridTemplateColumns:
                                                                            'repeat(2, 1fr)',
                                                                        gap: 1,
                                                                        justifyItems: 'center'
                                                                    }}
                                                                >

                                                                    {/* VIEW */}
                                                                    <Tooltip
                                                                        arrow
                                                                        title="View Details"
                                                                    >
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                ViewEnquiryDetails(item)
                                                                            }
                                                                        >
                                                                            <VisibilityIcon
                                                                                sx={{
                                                                                    color: '#0284c7'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>


                                                                    {/* EDIT */}
                                                                    {/* <Tooltip
                                                                        arrow
                                                                        title="Edit Enquiry"
                                                                    >
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                props.NavigateTo(
                                                                                    'enquiry/' + item._id
                                                                                )
                                                                            }
                                                                        >
                                                                            <EditIcon
                                                                                className="grey-theme-btn"
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip> */}


                                                                    {/* ADD INTERACTION */}
                                                                    <Tooltip arrow title="Add Interaction">
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => props.OpenInteractionBox(item)}
                                                                            sx={{
                                                                                color: '#0b4d78',
                                                                                '&:hover': {
                                                                                    bgcolor: '#e0f2fe'
                                                                                }
                                                                            }}
                                                                        >
                                                                            <ForumIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>

                                                                    {/* TIMELINE */}
                                                                    <Tooltip
                                                                        arrow
                                                                        title="View Timeline"
                                                                    >
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                props.GetTimelineData(
                                                                                    item._id
                                                                                )
                                                                            }
                                                                        >
                                                                            <TimelineIcon
                                                                                sx={{
                                                                                    color: '#7c3aed'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>

                                                                </Box>

                                                            </TableCell>

                                                        </TableRow>

                                                    ))

                                                    :

                                                    <TableRow>

                                                        <TableCell
                                                            colSpan={7}
                                                            align="center"
                                                        >
                                                            <Typography py={3}>
                                                                No Enquiry Found
                                                            </Typography>
                                                        </TableCell>

                                                    </TableRow>
                                            }

                                        </TableBody>
                                    </Table>

                                </TableContainer>



                            </Paper>

                            :

                            <Box>
                                {
                                    props.mystate.enquiryList?.length > 0 ?

                                        props.mystate.enquiryList.map((item, i) => (

                                            <Card
                                                key={item._id}
                                                sx={{
                                                    mb: 2,
                                                    borderRadius: 3,
                                                    boxShadow: 2
                                                }}
                                            >

                                                <CardContent>

                                                    {/* ================= HEADER ================= */}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'flex-start',
                                                            mb: 1
                                                        }}
                                                    >

                                                        <Box>

                                                            <Typography
                                                                variant="subtitle1"
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    color: '#042740'
                                                                }}
                                                            >
                                                                {item.enquiry_name || 'N/A'}
                                                            </Typography>

                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                            >
                                                                📍 {item.enquiry_city || 'N/A'}
                                                            </Typography>

                                                        </Box>


                                                        {/* ENQUIRY TYPE */}
                                                        <Chip
                                                            label={item.enquiry_type || 'N/A'}
                                                            size="small"
                                                            sx={{
                                                                fontWeight: 600,

                                                                backgroundColor:
                                                                    item.enquiry_type === 'Student'
                                                                        ? '#e0f2fe'
                                                                        : item.enquiry_type === 'Indian Partner'
                                                                            ? '#dcfce7'
                                                                            : '#f3e8ff',

                                                                color:
                                                                    item.enquiry_type === 'Student'
                                                                        ? '#0369a1'
                                                                        : item.enquiry_type === 'Indian Partner'
                                                                            ? '#15803d'
                                                                            : '#7e22ce'
                                                            }}
                                                        />

                                                    </Box>


                                                    {/* ================= CONTACT ================= */}
                                                    <Box sx={{ mb: 1 }}>

                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                            display="block"
                                                        >
                                                            Contact Details
                                                        </Typography>

                                                        {
                                                            item.enquiry_contact_name &&

                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                {item.enquiry_contact_name}
                                                            </Typography>
                                                        }

                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            📞 {item.enquiry_mobile || 'N/A'}
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            sx={{
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            ✉ {item.enquiry_email || 'N/A'}
                                                        </Typography>

                                                    </Box>


                                                    {/* ================= TYPE SPECIFIC DETAILS ================= */}

                                                    {/* STUDENT */}
                                                    {
                                                        item.enquiry_type === 'Student' && (

                                                            <Box
                                                                sx={{
                                                                    mb: 1,
                                                                    p: 1.5,
                                                                    backgroundColor: '#f8fafc',
                                                                    borderRadius: 2
                                                                }}
                                                            >

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    display="block"
                                                                    sx={{ mb: 0.5 }}
                                                                >
                                                                    Student Details
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    <b>German Level:</b>{' '}
                                                                    {item.enquiry_student_german_level || 'N/A'}
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    <b>B2 Pass Year:</b>{' '}
                                                                    {item.enquiry_student_b2_pass_year || 'N/A'}
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    <b>Language / Enquiry:</b>{' '}
                                                                    {item.enquiry_student_language_enquiry_name || 'N/A'}
                                                                </Typography>

                                                            </Box>

                                                        )
                                                    }


                                                    {/* INDIAN PARTNER */}
                                                    {
                                                        item.enquiry_type === 'Indian Partner' && (

                                                            <Box
                                                                sx={{
                                                                    mb: 1,
                                                                    p: 1.5,
                                                                    backgroundColor: '#f8fafc',
                                                                    borderRadius: 2
                                                                }}
                                                            >

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    display="block"
                                                                    sx={{ mb: 0.5 }}
                                                                >
                                                                    Indian Partner Details
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    <b>B2 Graduates:</b>{' '}
                                                                    {item.enquiry_indian_partner_b2_graduates || 'N/A'}
                                                                </Typography>

                                                            </Box>

                                                        )
                                                    }


                                                    {/* GERMAN PARTNER */}
                                                    {
                                                        item.enquiry_type === 'German Partner' && (

                                                            <Box
                                                                sx={{
                                                                    mb: 1,
                                                                    p: 1.5,
                                                                    backgroundColor: '#f8fafc',
                                                                    borderRadius: 2
                                                                }}
                                                            >

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    display="block"
                                                                    sx={{ mb: 0.5 }}
                                                                >
                                                                    German Partner Details
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    <b>Hiring Requirement:</b>{' '}
                                                                    {item.enquiry_german_partner_hiring_requirement || 'N/A'}
                                                                </Typography>

                                                                {
                                                                    item.enquiry_german_partner_msg && (

                                                                        <Typography
                                                                            variant="body2"
                                                                            color="text.secondary"
                                                                            sx={{
                                                                                mt: 0.5,
                                                                                wordBreak: 'break-word'
                                                                            }}
                                                                        >
                                                                            <b>Message:</b>{' '}
                                                                            {item.enquiry_german_partner_msg}
                                                                        </Typography>

                                                                    )
                                                                }

                                                            </Box>

                                                        )
                                                    }


                                                    {/* ================= STATUS ================= */}
                                                    <Box sx={{ mb: 1 }}>

                                                        <Chip
                                                            label={item.enquiry_status || 'N/A'}
                                                            size="small"
                                                            sx={{
                                                                fontWeight: 600,

                                                                backgroundColor:
                                                                    item.enquiry_status === 'Pending'
                                                                        ? '#fef3c7'
                                                                        : '#dcfce7',

                                                                color:
                                                                    item.enquiry_status === 'Pending'
                                                                        ? '#92400e'
                                                                        : '#166534'
                                                            }}
                                                        />

                                                    </Box>


                                                    {/* ================= FOOTER ================= */}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            pt: 1,
                                                            borderTop: '1px solid #e5e7eb'
                                                        }}
                                                    >

                                                        {/* ADDED DATE */}
                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                        >
                                                            {
                                                                FormatDateTime(
                                                                    item.enquiry_added_on
                                                                )
                                                            }
                                                        </Typography>


                                                        {/* ACTIONS */}
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                gap: 1
                                                            }}
                                                        >

                                                            {/* VIEW */}
                                                            <Tooltip
                                                                arrow
                                                                title="View Details"
                                                            >
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() =>
                                                                        ViewEnquiryDetails(item)
                                                                    }
                                                                >
                                                                    <VisibilityIcon
                                                                        sx={{
                                                                            color: '#0284c7'
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>


                                                            {/* EDIT */}
                                                            {/* <Tooltip
                                                                arrow
                                                                title="Edit Enquiry"
                                                            >
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() =>
                                                                        props.NavigateTo(
                                                                            'enquiry/' + item._id
                                                                        )
                                                                    }
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip> */}


                                                            {/* CALL */}
                                                            <Tooltip
                                                                arrow
                                                                title="Call Enquiry"
                                                            >
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() =>
                                                                        props.MakeNewCall(item)
                                                                    }
                                                                >
                                                                    <CallIcon
                                                                        sx={{
                                                                            color: '#16a34a'
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>


                                                            {/* TIMELINE */}
                                                            <Tooltip
                                                                arrow
                                                                title="View Timeline"
                                                            >
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() =>
                                                                        props.GetTimelineData(
                                                                            item._id
                                                                        )
                                                                    }
                                                                >
                                                                    <TimelineIcon
                                                                        sx={{
                                                                            color: '#7c3aed'
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>

                                                        </Box>

                                                    </Box>

                                                </CardContent>

                                            </Card>

                                        ))

                                        :

                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                py: 4
                                            }}
                                        >
                                            <Typography>
                                                No Enquiry Found
                                            </Typography>
                                        </Box>
                                }
                            </Box>


                        :

                        <Box>

                            <Skeleton height={75} />

                            <Skeleton
                                animation="wave"
                                variant="rectangular"
                                height={250}
                            />

                            <Skeleton height={75} />

                        </Box>
                }

                {
                    props.mystate.enquiryList.length > 0 ?


                        <TablePagination
                            rowsPerPageOptions={[10, 50, 100]}
                            component="div"
                            count={props.mystate.totalRecords}
                            rowsPerPage={props.mystate.perSet}
                            page={props.mystate.setNo - 1}
                            onPageChange={(e) =>
                                props.HandleChangePage(
                                    e,
                                    props.mystate.setNo - 1
                                )
                            }
                            onRowsPerPageChange={(e) =>
                                props.HandleChangeRowsPerPage(e)
                            }
                        />

                        :
                        null
                }

            </Box>

            {/* DETAILS MODAL */}
            <Modal
                open={openDetailsModal}
                onClose={() => setOpenDetailsModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "96%", md: "88%", lg: "82%" },
                        maxWidth: 1150,
                        maxHeight: "92vh",
                        overflowY: "auto",
                        bgcolor: "#f4f7fb",
                        borderRadius: 4,
                        outline: "none",
                        boxShadow: "0 24px 80px rgba(15, 23, 42, 0.25)"
                    }}
                >
                    {selectedEnquiry && (() => {
                        const enquiry = selectedEnquiry;

                        const type = (enquiry.enquiry_type || "")
                            .trim()
                            .toLowerCase();

                        const isStudent = type.includes("student");
                        const isIndianPartner =
                            type.includes("indian") || type.includes("indian partner");
                        const isGermanPartner =
                            type.includes("german") || type.includes("german partner");

                        const status = enquiry.enquiry_status || "Pending";

                        return (
                            <>
                                {/* HEADER */}

                                <Box
                                    sx={{
                                        background:
                                            "linear-gradient(135deg, #102a43 0%, #0b4d78 100%)",
                                        color: "#fff",
                                        px: { xs: 2.5, md: 4 },
                                        py: { xs: 3, md: 4 }
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="flex-start"
                                        spacing={2}
                                    >
                                        <Box sx={{ minWidth: 0 }}>
                                            <Typography
                                                variant="overline"
                                                sx={{
                                                    color: "#b9d9ef",
                                                    fontWeight: 700,
                                                    letterSpacing: 1.5
                                                }}
                                            >
                                                ENQUIRY DETAILS
                                            </Typography>

                                            <Typography
                                                variant="h4"
                                                sx={{
                                                    fontWeight: 800,
                                                    mt: 0.5,
                                                    mb: 2,
                                                    fontSize: {
                                                        xs: "1.5rem",
                                                        md: "2rem"
                                                    },
                                                    overflowWrap: "anywhere"
                                                }}
                                            >
                                                {getEnquiryValue(enquiry.enquiry_name)}
                                            </Typography>

                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                flexWrap="wrap"
                                                useFlexGap
                                            >
                                                <Chip
                                                    label={getEnquiryValue(enquiry.enquiry_type)}
                                                    size="small"
                                                    sx={{
                                                        color: "#fff",
                                                        fontWeight: 700,
                                                        bgcolor: getEnquiryTypeColor(
                                                            enquiry.enquiry_type
                                                        )
                                                    }}
                                                />

                                                <Chip
                                                    label={getEnquiryValue(
                                                        enquiry.enquiry_unique_id
                                                    )}
                                                    size="small"
                                                    sx={{
                                                        color: "#fff",
                                                        fontWeight: 600,
                                                        bgcolor: "rgba(255,255,255,0.14)"
                                                    }}
                                                />
                                            </Stack>
                                        </Box>

                                        <IconButton
                                            aria-label="Close enquiry details"
                                            onClick={() => setOpenDetailsModal(false)}
                                            sx={{
                                                color: "#fff",
                                                bgcolor: "rgba(255,255,255,0.12)",
                                                "&:hover": {
                                                    bgcolor: "rgba(255,255,255,0.22)"
                                                }
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </Stack>

                                    <Divider
                                        sx={{
                                            my: 3,
                                            borderColor: "rgba(255,255,255,0.16)"
                                        }}
                                    />

                                    <Stack
                                        direction={{ xs: "column", sm: "row" }}
                                        justifyContent="space-between"
                                        alignItems={{ xs: "flex-start", sm: "center" }}
                                        spacing={1.5}
                                    >
                                        <Box>
                                            <Typography
                                                variant="caption"
                                                sx={{ color: "#b9d9ef" }}
                                            >
                                                Enquiry status
                                            </Typography>

                                            <Box sx={{ mt: 0.75 }}>
                                                <Chip
                                                    label={status}
                                                    size="small"
                                                    sx={{
                                                        fontWeight: 700,
                                                        color: "#fff",
                                                        bgcolor:
                                                            status.toLowerCase() === "active"
                                                                ? "#15803d"
                                                                : status.toLowerCase() === "inactive"
                                                                    ? "#dc2626"
                                                                    : "#64748b"
                                                    }}
                                                />
                                            </Box>
                                        </Box>

                                        <Box>
                                            <Typography
                                                variant="caption"
                                                sx={{ color: "#b9d9ef" }}
                                            >
                                                Created on
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                sx={{ fontWeight: 600, mt: 0.5 }}
                                            >
                                                {formatEnquiryDate(enquiry.enquiry_added_on)}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Box>

                                {/* MODAL BODY */}

                                <Box sx={{ p: { xs: 2, md: 3 } }}>

                                    {/* CONTACT INFORMATION */}

                                    <EnquirySection
                                        title="Contact Information"
                                        subtitle="Basic details and contact information for this enquiry."
                                    >
                                        <Grid container spacing={2}>
                                            <DetailItem
                                                label="Full Name"
                                                value={enquiry.enquiry_name}
                                            />

                                            <DetailItem
                                                label="Enquiry ID"
                                                value={enquiry.enquiry_unique_id}
                                            />

                                            <DetailItem
                                                label="Email Address"
                                                value={enquiry.enquiry_email}
                                            />

                                            <DetailItem
                                                label="Mobile Number"
                                                value={enquiry.enquiry_mobile}
                                            />

                                            <DetailItem
                                                label="City"
                                                value={enquiry.enquiry_city}
                                            />

                                            <DetailItem
                                                label="Enquiry Type"
                                                value={enquiry.enquiry_type}
                                            />
                                        </Grid>
                                    </EnquirySection>

                                    {/* STUDENT DETAILS */}

                                    {isStudent && (
                                        <EnquirySection
                                            title="Student Details"
                                            subtitle="German language proficiency and training preference."
                                        >
                                            <Grid container spacing={2}>
                                                <DetailItem
                                                    label="German Language Level"
                                                    value={
                                                        enquiry.enquiry_student_german_level
                                                    }
                                                />

                                                <DetailItem
                                                    label="B2 Exam Pass Year"
                                                    value={
                                                        enquiry.enquiry_student_b2_pass_year
                                                    }
                                                />

                                                <DetailItem
                                                    label="Language Enquiry / Institute"
                                                    value={
                                                        enquiry.enquiry_student_language_enquiry_name
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </EnquirySection>
                                    )}

                                    {/* INDIAN PARTNER DETAILS */}

                                    {isIndianPartner && (
                                        <EnquirySection
                                            title="Indian Partner Details"
                                            subtitle="Contact person and available B2-qualified graduates."
                                        >
                                            <Grid container spacing={2}>
                                                <DetailItem
                                                    label="Contact Person"
                                                    value={enquiry.enquiry_contact_name}
                                                />

                                                <DetailItem
                                                    label="B2 Graduates"
                                                    value={
                                                        enquiry.enquiry_indian_partner_b2_graduates
                                                    }
                                                />
                                            </Grid>
                                        </EnquirySection>
                                    )}

                                    {/* GERMAN PARTNER DETAILS */}

                                    {isGermanPartner && (
                                        <EnquirySection
                                            title="German Partner Details"
                                            subtitle="Hiring requirements and additional information."
                                        >
                                            <Grid container spacing={2}>
                                                <DetailItem
                                                    label="Contact Person"
                                                    value={enquiry.enquiry_contact_name}
                                                />

                                                <DetailItem
                                                    label="Hiring Requirement"
                                                    value={
                                                        enquiry.enquiry_german_partner_hiring_requirement
                                                    }
                                                    fullWidth
                                                />

                                                <DetailItem
                                                    label="Additional Message"
                                                    value={enquiry.enquiry_german_partner_msg}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </EnquirySection>
                                    )}

                                    {/* SOURCE AND OWNERSHIP */}

                                    <EnquirySection
                                        title="Source & Ownership"
                                        subtitle="Track how the enquiry entered the system and who added it."
                                    >
                                        <Grid container spacing={2}>
                                            <DetailItem
                                                label="Enquiry Source"
                                                value={enquiry.enquiry_source}
                                            />

                                            <DetailItem
                                                label="Added By"
                                                value={enquiry.enquiry_added_by}
                                            />
                                        </Grid>
                                    </EnquirySection>

                                    {/* AUDIT INFORMATION */}

                                    <EnquirySection
                                        title="Activity & Audit"
                                        subtitle="Creation and latest update information."
                                    >
                                        <Grid container spacing={2}>
                                            <DetailItem
                                                label="Created On"
                                                value={formatEnquiryDate(
                                                    enquiry.enquiry_added_on
                                                )}
                                            />

                                            <DetailItem
                                                label="Last Updated By"
                                                value={enquiry.enquiry_updated_by}
                                            />

                                            <DetailItem
                                                label="Last Updated On"
                                                value={formatEnquiryDate(
                                                    enquiry.enquiry_updated_on
                                                )}
                                                fullWidth
                                            />
                                        </Grid>
                                    </EnquirySection>

                                    {/* FOOTER */}

                                    <Stack
                                        direction="row"
                                        justifyContent="flex-end"
                                        sx={{ pt: 1 }}
                                    >
                                        <Button
                                            variant="contained"
                                            onClick={() => setOpenDetailsModal(false)}
                                            sx={{
                                                textTransform: "none",
                                                fontWeight: 700,
                                                px: 4,
                                                py: 1.2,
                                                borderRadius: 2,
                                                bgcolor: "#102a43",
                                                "&:hover": {
                                                    bgcolor: "#0b4d78"
                                                }
                                            }}
                                        >
                                            Close
                                        </Button>
                                    </Stack>
                                </Box>
                            </>
                        );
                    })()}
                </Box>
            </Modal>

            <Modal
                open={props.mystate.openInteractionBox}
                // onClose={() => props.ToggleInteractionBox()}
                onClose={(event, reason) => {
                    // ❌ Prevent close when clicking backdrop
                    if (reason === "backdropClick") return;
                    props.ToggleInteractionBox()
                }}
                // hideBackdrop={true}
                disableEscapeKeyDown={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-Interaction"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Add Interaction
                    </Typography>
                    <Box mt={1}>
                        <FormControl fullWidth>
                            <TextField
                                select
                                value={props.interactionData.ddlEnquiryStatus || ''}
                                label="Select Status*"
                                error={props.interactionData.ddlEnquiryStatusErr == undefined || props.interactionData.ddlEnquiryStatusErr == '' ? false : true}
                                onChange={(e) => props.HandleInputs(e, 'ddlEnquiryStatus')}
                            >

                                <MenuItem key={''} value={'RNR'}>{'RNR'}</MenuItem>
                                <MenuItem key={''} value={'Call Back'}>{'Call Back'}</MenuItem>
                                <MenuItem key={''} value={'On Hold'}>{'On Hold'}</MenuItem>
                                <MenuItem key={''} value={'Dead'}>{'Dead'}</MenuItem>
                                <MenuItem key={''} value={'Qualified'}>{'Qualified'}</MenuItem>

                            </TextField>
                            <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlEnquiryStatusErr}</FormHelperText>
                        </FormControl>
                    </Box>
                    {
                        props.interactionData.ddlEnquiryStatus === 'Call Back' ?
                            <Box mt={1}>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtCallBackDateTime')} label="CallBack DateTime*" value={dayjs(props.interactionData.txtCallBackDateTime != undefined ? props.interactionData.txtCallBackDateTime : '')} slotProps={{
                                                textField: {
                                                    error: props.interactionData.txtCallBackDateTimeErr == undefined || props.interactionData.txtCallBackDateTimeErr == '' ? false : true,
                                                },
                                            }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtCallBackDateTimeErr}</FormHelperText>

                            </Box>
                            :
                            null
                    }
                    {
                        props.interactionData.ddlEnquiryStatus === 'Onboarding' ?
                            <Box mt={1}>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtOnboardingDateTime')} label="Onboarding DateTime*" value={dayjs(props.interactionData.txtOnboardingDateTime != undefined ? props.interactionData.txtOnboardingDateTime : '')} slotProps={{
                                                textField: {
                                                    error: props.interactionData.txtOnboardingDateTimeErr == undefined || props.interactionData.txtOnboardingDateTimeErr == '' ? false : true,
                                                },
                                            }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtOnboardingDateTimeErr}</FormHelperText>

                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlEnquiryStatus === 'Dead' ?
                            <Box mt={1}>
                                <TextField multiline rows={2} className="text-input" id="txtDeadReason" name='txtDeadReason' error={props.interactionData.txtDeadReasonErr == undefined || props.interactionData.txtDeadReasonErr == '' ? false : true} helperText={props.interactionData.txtDeadReasonErr} onChange={(e) => props.HandleInputs(e, 'txtDeadReason')} value={props.interactionData.txtDeadReason || ''} label="Dead Reason" variant="outlined" />
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtDeadReasonErr}</FormHelperText>
                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlEnquiryStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadDepartment || ''}
                                        label="Select Department*"
                                        error={props.interactionData.ddlLeadDepartmentErr == undefined || props.interactionData.ddlLeadDepartmentErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadDepartment')}
                                    >
                                        <MenuItem value={'Sales TL'}>{'Sales TL'}</MenuItem>
                                        <MenuItem value={'Sales'}>{'Sales'}</MenuItem>
                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadDepartmentErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }
                    {
                        props.interactionData.ddlEnquiryStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadOwner || ''}
                                        label="Select Owner*"
                                        error={props.interactionData.ddlLeadOwnerErr == undefined || props.interactionData.ddlLeadOwnerErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadOwner')}
                                    >
                                        {
                                            props.mystate.userListData.map((item, i) =>
                                                item.user_profile_name === props.interactionData.ddlLeadDepartment ?
                                                    <MenuItem key={i} value={item.user_name}>{item.user_name}</MenuItem>
                                                    :
                                                    null
                                            )
                                        }


                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadOwnerErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }



                    <Box mt={1}>
                        <TextField multiline rows={4} className="text-input" id="txtInteractionDesc" name='txtInteractionDesc' error={props.interactionData.txtInteractionDescErr == undefined || props.interactionData.txtInteractionDescErr == '' ? false : true} helperText={props.interactionData.txtInteractionDescErr} onChange={(e) => props.HandleInputs(e, 'txtInteractionDesc')} value={props.interactionData.txtInteractionDesc || ''} label="Enter Description" variant="outlined" />
                        <FormHelperText style={{ fontSize: 10, textAlign: 'end', color: '#042740', fontWeight: 'bold' }}>{'Max Char. 60'}</FormHelperText>
                    </Box>
                    <Box mt={2}>
                        <Grid container>
                            <Grid>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddNewInteraction()}>Add Interaction</Button>
                            </Grid>

                        </Grid>
                    </Box>

                </Box>
            </Modal>

            {/* ALERT */}
            <Snackbar
                open={props.mystate.showAlert}
                autoHideDuration={1000}
                onClose={() =>
                    props.HandleCloseAlertMsg(
                        props.mystate.alertType
                    )
                }
            >

                <Alert
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {props.mystate.alertMsg}
                </Alert>

            </Snackbar>

            <Dialog
                open={props.timelinePopup}
                onClose={() => props.CloseTimeLine()}
                fullWidth
                maxWidth='md'
            >

                <DialogTitle>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >

                        <Typography
                            variant='h6'
                            fontWeight={600}
                        >
                            Enquiry Timeline
                        </Typography>

                        <IconButton
                            onClick={() => props.CloseTimeLine()}
                        >
                            <CloseIcon />
                        </IconButton>

                    </Box>

                </DialogTitle>

                <DialogContent dividers>

                    <Timeline position='right'>

                        {props.timelineData && props.timelineData.map((item, index) => (

                            <TimelineItem key={index}>

                                <TimelineSeparator>

                                    <TimelineDot
                                        color={
                                            item.timeline_type === 'call'
                                                ? 'success'
                                                : 'primary'
                                        }
                                    >

                                        {
                                            item.timeline_type === 'call'
                                                ? <CallIcon fontSize='small' />
                                                : <ForumIcon fontSize='small' />
                                        }

                                    </TimelineDot>

                                    {
                                        index !== props.timelineData.length - 1 &&
                                        <TimelineConnector />
                                    }

                                </TimelineSeparator>

                                <TimelineContent>

                                    <Box
                                        sx={{
                                            p: 2,
                                            border: '1px solid #e5e7eb',
                                            borderRadius: 2,
                                            mb: 2,
                                            background: '#fff'
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mb: 1,
                                                flexWrap: 'wrap'
                                            }}
                                        >

                                            <Chip
                                                size='small'
                                                label={
                                                    item.timeline_type === 'call'
                                                        ? 'Call'
                                                        : 'Interaction'
                                                }
                                                color={
                                                    item.timeline_type === 'call'
                                                        ? 'success'
                                                        : 'primary'
                                                }
                                            />

                                            <Typography
                                                variant='caption'
                                                color='text.secondary'
                                            >
                                                {item.added_on}
                                            </Typography>

                                        </Box>

                                       
{
    item.timeline_type === 'interaction' && (
        <>
            <Typography
                variant="body2"
                fontWeight={600}
                gutterBottom
            >
                Status:{" "}
                <Chip
                    size="small"
                    label={item.interaction_status || 'N/A'}
                    sx={{
                        ml: 0.5,
                        fontWeight: 600,
                        bgcolor:
                            item.interaction_status === 'Qualified'
                                ? '#dcfce7'
                                : item.interaction_status === 'Dead'
                                    ? '#fee2e2'
                                    : item.interaction_status === 'Call Back'
                                        ? '#dbeafe'
                                        : item.interaction_status === 'Pending'
                                            ? '#fef3c7'
                                            : '#f1f5f9',
                        color:
                            item.interaction_status === 'Qualified'
                                ? '#166534'
                                : item.interaction_status === 'Dead'
                                    ? '#b91c1c'
                                    : item.interaction_status === 'Call Back'
                                        ? '#1d4ed8'
                                        : item.interaction_status === 'Pending'
                                            ? '#92400e'
                                            : '#475569'
                    }}
                />
            </Typography>

            {item.description && (
                <Typography
                    variant="body2"
                    sx={{
                        mt: 1,
                        mb: 1.5,
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'anywhere'
                    }}
                >
                    {item.description}
                </Typography>
            )}

            {item.call_back_date_time && (
                <Typography
                    variant="body2"
                    sx={{ mb: 1, color: '#1d4ed8' }}
                >
                    <b>Callback:</b>{" "}
                    {item.call_back_date_time}
                </Typography>
            )}

            {item.dead_date_time && (
                <Typography
                    variant="body2"
                    sx={{ mb: 1, color: '#b91c1c' }}
                >
                    <b>Marked Dead:</b>{" "}
                    {item.dead_date_time}
                </Typography>
            )}

            <Typography
                variant="caption"
                color="text.secondary"
            >
                Added by: {item.added_by || 'N/A'}
            </Typography>
        </>
    )
}


                                        {
                                            item.timeline_type === 'call' && (

                                                <>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        Call Status :
                                                        {' '}
                                                        <b>
                                                            {item.call_status}
                                                        </b>
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        From :
                                                        {' '}
                                                        {item.call_from_number}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        To :
                                                        {' '}
                                                        {item.call_to_number}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        Duration :
                                                        {' '}
                                                        <b>
                                                            {formatDuration(item.duration)}
                                                        </b>
                                                    </Typography>

                                                    {
                                                        item.recording_url && (

                                                            <Box sx={{ mt: 2 }}>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ mb: 1 }}
                                                                >
                                                                    <b>Recording</b>
                                                                </Typography>

                                                                <audio
                                                                    controls
                                                                    preload="none"
                                                                    style={{
                                                                        width: '100%'
                                                                    }}
                                                                >
                                                                    <source src={item.recording_url} />
                                                                </audio>
                                                            </Box>

                                                        )
                                                    }

                                                    <Typography
                                                        variant='body2'
                                                    >
                                                        By :
                                                        {' '}
                                                        {item.call_by}
                                                    </Typography>

                                                </>

                                            )
                                        }

                                    </Box>

                                </TimelineContent>

                            </TimelineItem>

                        ))}

                    </Timeline>

                </DialogContent>

            </Dialog>

        </Box>
    );
};